/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_EMAIL_DETAILS = gql`
  query Users($where: UserWhere) {
    users(where: $where) {
      phoneNo
      country
      city
      address
      nationality
      website
      logo
      description
      email
      name
      id
      employeeOfOrg {
        id
        name
        email
        description
        logo
        orgType
        website
        nationality
        address
        city
        country
        phoneNo
        socialLinks {
          type
          url
        }
      }
      employedInOrgs {
        id
        name
        email
        description
        logo
        orgType
        website
        nationality
        address
        city
        country
        phoneNo
        socialLinks {
          type
          url
        }
      }
    }
  }
`;
